import { Box, Card, CardContent, Divider } from '@mui/material'
import HistoryItemField from '@component/HistoryItemField'
import { LooksOneTwoTone } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { TwoWaySlabInput } from '@core/const'

export interface TwoWaySlabHistory extends TwoWaySlabInput {
  type: 'TwoWaySlab',
  result: number
}

interface Props {
  history: TwoWaySlabHistory
}
function TwoWaySlabHistoryItem ({ history }: Props) {
  const { t } = useTranslation()

  return (
    <Card>
      <CardContent className="flex gap-16 !py-8">
        <LooksOneTwoTone />
        <Box className="grid grid-cols-2 gap-8 min-w-[16rem] overflow-auto">
          <HistoryItemField
            label={t('GLOSSARY.LONGSIDE_SPAN')}
            unit="m"
            value={history.longSideSpan}
          />
          <HistoryItemField
            label={t('GLOSSARY.SHORTSIDE_SPAN')}
            unit="m"
            value={history.shortSideSpan}
          />
        </Box>
        <Box>
          <Divider orientation="vertical" />
        </Box>
        <HistoryItemField
          label={t('GLOSSARY.MIN_REQUIRED_THICKNESS')}
          unit="mm"
          value={history.result.toFixed(0)}
        />
      </CardContent>
    </Card>
  )
}

export default TwoWaySlabHistoryItem
